export enum DeployPriorityCompoundRuleOperator {
  Or = 0,
  And = 1,
}
